import { detectBrowser } from '../pojemnikApi/utils'
import { getOS } from '../utils'
import _ from 'lodash'

const compId = Wix.Utils.getOrigCompId()
const measurement_id = `G-G9WD6K44Q0`
const api_secret = `EBA2j8GtTxWJGa6r56u_fg`
const googleEventName = 'publish'

export const sendGAEvent = (sendSettings, compId) => {
    const client_id = sessionStorage.getItem(`client_id-${compId}`)
    if (!client_id) return
    console.log('================ sendGAEvent =================', sendSettings)

    const data = {
        client_id: client_id,
        events: [{
            name: googleEventName,
            params: {
                ...sendSettings
            },
        }]
    }
    fetch(`https://www.google-analytics.com/mp/collect?measurement_id=${measurement_id}&api_secret=${api_secret}`, {
        method: "POST",
        body: JSON.stringify(data)
    })
    .then(res => {
        // console.log(res)
    })
    .catch(res => {
        console.log(res)
    })
}

// сохранить дополнительные настройки в сессию, чтобы при отправке данных взять их из этого объекта
export const saveGAData = (fieldName, fieldData) => {
    const ssData = JSON.parse(sessionStorage.getItem(`${compId}-text-slider-GA`)) || {}
    const newssGAData = { [fieldName]: `${fieldData}` }
    const ssGAData = { ...ssData, ...newssGAData }

    sessionStorage.setItem(`${compId}-text-slider-GA`, JSON.stringify(ssGAData))
}

// сохранить клиентский идентификатор, который выдаётся гугл аналитикой
// при каждой отправке данных он должен быть разный,
// иначе в статистике на сайте GA данные приходят с пометкой not set
export const saveGAClientID = () => {
    gtag('get', measurement_id, 'client_id', client_id => {
        sessionStorage.setItem(`client_id-${compId}`, client_id)
    })
}

// собрать статистику с настроек
export const prepareSettingsAndSendGA = (incomingSettings) => {
    const settings = _.cloneDeep(incomingSettings)
    // если разработчик, то статистику не отправляем
    if (settings.isDeveloper) return

    const compId = Wix.Utils.getCompId()
    const sendGAData = JSON.parse(sessionStorage.getItem(`sendGAData-${compId}`))
    
    if (sendGAData && compId) {

        const instancesArr = JSON.parse(sessionStorage.getItem('impressiveTextSliderInstances')) || []
        const sessionTimeArr = JSON.parse(sessionStorage.getItem(`settingsTimeArr-${compId}`)) || []

        let sendSettings = {
            premium: settings.isProfessionalPremium ? 'Premium' : settings.userInTrialMode ? 'Trial' : 'Free',
            widgetSize: `${Math.round(window.innerWidth/10)*10}*${Math.round(window.innerHeight/10)*10}`,
            slidesNumber: settings.settings.slides.filter(slide => !slide.isHide).length,
            slideAnimation: settings.settings.animationMode,
            parallax: settings.settings.hasParallax ? settings.settings.parallaxType : 'off',
            customFonts: settings.settings.customFonts ? settings.settings.customFonts.length : 0,
            captions: getUsedCaptions(settings.settings.slides),
            navigation: getUsedNavigation(settings.settings),
            textLink: getUsedTextLink(settings.settings.slides),
            textDirection: getUsedTextDirection(settings.settings.slides),
            stamp: getUsedStamp(),
            textAnimIn: getTextAnimationsAppearence(settings.settings.slides, 'text', 'animationIn'),
            textAnimOut: getTextAnimationsAppearence(settings.settings.slides, 'text', 'animationOut'),
            buttonAnimIn: getTextAnimationsAppearence(settings.settings.slides, 'button', 'animationIn'),
            buttonAnimOut: getTextAnimationsAppearence(settings.settings.slides, 'button', 'animationOut'),
            buttonAnimHover: getTextAnimationsAppearence(settings.settings.slides, 'button', 'animation'),
            boxAnimIn: getTextAnimationsAppearence(settings.settings.slides, 'box', 'animationIn'),
            boxAnimOut: getTextAnimationsAppearence(settings.settings.slides, 'box', 'animationOut'),
            system: getOS() + ' ' + detectBrowser(),
            screen: `${Math.round(window.screen.width * window.devicePixelRatio)}x${Math.round(window.screen.height * window.devicePixelRatio)}`,
            time: getTimeOfUseSettings(sessionTimeArr),
            instancesCount: instancesArr.length
        }
        
        const ssData = JSON.parse(sessionStorage.getItem(compId + '-text-slider-GA')) || {}
        sendSettings = {...ssData, ...sendSettings}
        
        sendGAEvent(sendSettings, compId)
        sessionStorage.removeItem(`sendGAData-${compId}`)
        sessionStorage.removeItem(`settingsTimeArr-${compId}`)
    }
}

// сохранить в массив compid всех приложений, которые присутствуют на странице, чтобы подсчитать общее количество виджетов 
export function saveWidgetInstances() {
    const instancesArr = JSON.parse(sessionStorage.getItem('impressiveTextSliderInstances')) || []
    const compId = Wix.Utils.getCompId()
    const exist = instancesArr.findIndex(id => id === compId)
    if (exist === -1) {
        instancesArr.push(compId)
    }
    sessionStorage.setItem('impressiveTextSliderInstances', JSON.stringify(instancesArr))
} 

// записать время открытия settings
export function startTimeOfSettingUse(compId) {
    const itemName = `settingsTimeArr-${compId}`
    const sessionTimeArr = JSON.parse(sessionStorage.getItem(itemName)) || []
    sessionTimeArr.push({start: Date.now(), finish: null})
    sessionStorage.setItem(itemName, JSON.stringify(sessionTimeArr))
}

// записать время закрытия окна settings
function finishTimeOfSettingUse(compId) {
    const itemName = `settingsTimeArr-${compId}`
    const sessionTimeArr = JSON.parse(sessionStorage.getItem(itemName)) || []
    const length = sessionTimeArr.length
    if (!length) return
    sessionTimeArr[length - 1].finish = Date.now()
    sessionStorage.setItem(itemName, JSON.stringify(sessionTimeArr))
}

// разрешить отправку статистики, если окно settings закрыли
export function closeSettings(compId) {
    sessionStorage.setItem(`sendGAData-${compId}`, true)
    finishTimeOfSettingUse(compId)
}

// получить общее время настройки виджета за сессию
function getTimeOfUseSettings(timeArr) {
    const allTime = timeArr.reduce((accum, period) => {
        if (typeof period.finish === 'number' && typeof period.start === 'number') {
            return accum + (period.finish - period.start)
        } else return 0
    }, 0)
    return msConversion(allTime)
}

// конвертировать миллисекунды в часы : минуты : секунды
function msConversion(millis) {
    let sec = Math.floor(millis / 10000) * 10;
    let hrs = Math.floor(sec / 3600);
    sec -= hrs * 3600;
    let min = Math.floor(sec / 60);
    sec -= min * 60;
  
    sec = '' + sec;
    sec = ('00' + sec).substring(sec.length);
  
    if (hrs > 0) {
        min = '' + min;
        min = ('00' + min).substring(min.length);
        return hrs + ":" + min + ":" + sec;
    }
    else {
        return min + ":" + sec;
    }
}

// получить строку с количеством каждого вида капч
const getUsedCaptions = (slides) => {
    const captionsCount = { text: 0, button: 0, shape: 0, box: 0 }
    slides.forEach(slide => {
        if (slide.isHide) return
        slide.captions.forEach(caption => {
            captionsCount[caption.type] += 1
        })
    })
    return Object.keys(captionsCount).map(key => `${key}:${captionsCount[key]}`).join(', ')
}

// получить строку с используемыми контролами навигации
const getUsedNavigation = (settings) => {
    const obj = {
        Dots: settings.hasDots, 
        Arrows: settings.hasArrows
    }
    return Object.keys(obj).map(key => obj[key] ? `${key}` : false).filter(x => x).join(', ') || 'none'
}

// если хотя бы у одной текстовой капчи используется ссылка, отправляем true
const getUsedTextLink = (slides) => {
    return slides.some(slide => {
        if (slide.isHide) return false
        return slide.captions.some(caption => {
            if (caption.type === 'text') {
                return Boolean(caption.linkTo)
            }
        })
    })
}

// получить строку с количеством капч с различным направление текста
const getUsedTextDirection = (slides) => {
    const obj = { toRight: 0, toLeft: 0 }
    slides.forEach(slide => {
        if (slide.isHide) return
        slide.captions.forEach(caption => {
            if (caption.type === 'text') {
                const direction = caption.isRTL ? 'toLeft' : 'toRight'
                obj[direction] += 1
            }
        })
    })
    obj.toRight = Math.round((obj.toRight / (obj.toRight + obj.toLeft)) * 100)
    obj.toLeft = 100 - obj.toRight
    return Object.keys(obj).map(key => (obj[key] ? `${key}:${obj[key]}%` : '')).join(' ').trim() || 'text not used'
}

// зафиксировать удачное применение штампа
export function incrementUsingStamp() {
    const increment = JSON.parse(sessionStorage.getItem('incrementTextSlider')) || 0
    sessionStorage.setItem('incrementTextSlider', JSON.stringify(increment + 1))
}

// получить количество применённых копирований свойств при помощи штампа
const getUsedStamp = () => {
    const increment = JSON.parse(sessionStorage.getItem('incrementTextSlider')) || 0
    sessionStorage.removeItem('incrementTextSlider')
    return increment
}

// получить строку из трёх наиволее используемых анимаций
function getTextAnimationsAppearence(slides, captionType, animPart) {
    const animationsObj = {}
    slides.forEach(slide => {
        if (slide.isHide) return
        slide.captions.forEach(caption => {
            if (caption.type === captionType) {
                let animationName = caption[animPart]
                if (animPart === 'animation' && typeof caption[animPart] === 'object') {
                    animationName = caption[animPart].value
                } 
                animationsObj[animationName] = (animationsObj[animationName] || 0) + 1
            }
        })
    })
    const result = Object.keys(animationsObj).map(key => ({name: key, count: animationsObj[key]}) )
    return result.sort((a,b) => {return b.count - a.count}).slice(0,3).map(x => x.name).join(', ')
}